import type { IBankStatement } from '@/shared/types/scoring-info.types';

/**
 * Итоги выписки: пополнения — пополнения, поступления со своих счетов и кредитные
 * средства; расходы — снятия, переводы (в том числе на свои счета), покупки и разное.
 */
export const getStatementTotals = (
  statement: IBankStatement
): { income: number; expenses: number } => ({
  income: statement.topUp + statement.ownIncome + statement.credit,
  expenses:
    statement.withdrawals +
    statement.transfersOut +
    statement.ownTransfersOut +
    statement.purchases +
    statement.misc
});
